// IntegratedProjectTable.js
import { useState, useCallback, useRef } from 'react';
import './ChecklistTable.css';
// import MDTasksTable from "./Components/Project/TaskData/MDTaskTable.js";
// import DesignTable from "./Components/Design/DesignTable.js";
// import MetaData from "./Components/Project/MetaData/MetaData.js";
import { useParams } from 'react-router-dom';
import CustomTablesScreen from './Components/CustomTables/CustomTables.tsx';
import CustomTableView from './Components/CustomTables/CustomTableView.js';

const IntegratedProjectTable = () => {
  const { matterId } = useParams();

  // Comment out unused states
  // const [activeCheck, setActiveCheck] = useState(null);
  // const [selectedView, setSelectedView] = useState("referenceDoc");
  // const [projectTableData, setProjectTableData] = useState([]);
  // const [deliverablesData, setDeliverablesData] = useState([]);
  // const [projectDesignData, setProjectDesignData] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [selectedSubView, setSelectedSubView] = useState("Overall Design");

  // Custom Tables state
  const [selectedTableData, setSelectedTableData] = useState(null);
  const [customTablesLoading, setCustomTablesLoading] = useState(false);

  // Cache of the latest edited rows per table id. The banner (CustomTables)
  // only fetches rows once, so without this cache, switching between tables
  // would re-derive rows from the stale fetch and hide freshly-saved edits
  // until a full page refresh.
  const editedRowsByTableId = useRef({});

  // Memoize callbacks to prevent infinite loops
  const handleTableSelect = useCallback((table, index) => {
    const editedRows = table && editedRowsByTableId.current[table.id];
    setSelectedTableData(editedRows ? { ...table, rows: editedRows } : table);
  }, []);

  // Called by CustomTableView after a successful save so a later re-selection of
  // this table reflects the newly-saved rows. We only update the ref cache (used
  // on re-selection) and intentionally do NOT touch selectedTableData for the
  // currently-mounted table: its local rows are already correct, and mutating
  // the table prop here would retrigger CustomTableView's row-reset effect,
  // causing flicker and a data-loss window under rapid async saves.
  const handleRowsSaved = useCallback((tableId, newRows) => {
    editedRowsByTableId.current[tableId] = newRows;
  }, []);

  const handleLoadingChange = useCallback((loading) => {
    setCustomTablesLoading(loading);
  }, []);

  // Comment out unused tableNameMap
  // const tableNameMap = {
  //   "Overall Design": "overall_design",
  //   "Process Bernie": "process_bernie",
  //   "Piping": "piping",
  //   "Civil": "civil_structural",
  //   "Wellheads": "wellheads",
  //   "Highlines": "highlines",
  //   "Meter": "meter_package",
  //   "Separator": "separator",
  //   "Fg Scrubber": "fg_scrubber",
  //   "Generator": "generator",
  //   "Ia Compressor": "ia_compressor",
  //   "ChemicalPump": "chemical_pump_package",
  //   "Sirus Pump": "for_sirius_pump",
  //   "Flare": "flare",
  //   "Pipeline Riser": "pipeline_riser",
  //   "Electrical": "electrical",
  //   "InstrumentationControls": "instrumentation_controls",
  //   "Dc Submittal": "before_dc_submittal",
  // };

  // Comment out unused useEffect hooks
  // useEffect(() => {
  //   if (!activeCheck) {
  //     if (selectedView === "referenceDoc") {
  //       ChecklistService.getProjectTableDataByMatterId(matterId)
  //         .then((data) => {
  //           const indexedData = data.map((row, i) => ({ ...row, rowIndex: i }));
  //           setProjectTableData(indexedData);
  //         })
  //         .catch((err) => console.error("Error fetching ref doc data:", err));
  //     } else if (selectedView === "deliverables") {
  //       ChecklistService.getDeliverablesByMatterId(matterId)
  //         .then((data) => {
  //           const indexedData = data.map((row, i) => ({ ...row, rowIndex: i }));
  //           setDeliverablesData(indexedData);
  //         })
  //         .catch((err) => console.error("Error fetching deliverables:", err));
  //     }
  //   }
  // }, [activeCheck, selectedView, matterId]);

  // useEffect(() => {
  //   if (activeCheck === "CHK_003") {
  //     const tableName = tableNameMap[selectedSubView];
  //     if (matterId && tableName) {
  //       setLoading(true);
  //       ChecklistService.getProjectDesignData(matterId, tableName)
  //         .then((data) => {
  //           setProjectDesignData(data);
  //           setLoading(false);
  //         })
  //         .catch((error) => {
  //           console.error("Error fetching CHK_003 data:", error);
  //           setLoading(false);
  //         });
  //     }
  //   }
  // }, [activeCheck, selectedSubView, matterId]);

  // Comment out unused handleSaveRefDoc
  // const handleSaveRefDoc = async (updatedTasks) => {
  //   if (selectedView !== "referenceDoc" || activeCheck) return;
  //   try {
  //     for (const task of updatedTasks) {
  //       await ChecklistService.updateProjectTableData(task.pd_id, task);
  //     }
  //     alert("Changes saved successfully!");
  //   } catch (error) {
  //     console.error("Error saving changes:", error);
  //     alert("Failed to save changes.");
  //   }
  // };

  const renderBanner = () => {
    // Only show Custom Tables banner
    return (
      <div className="custom-tables-banner">
        <CustomTablesScreen
          matterId={matterId}
          onTableSelect={handleTableSelect}
          onLoadingChange={handleLoadingChange}
        />
      </div>
    );
  };

  const renderContent = () => {
    // Only show Custom Tables content
    if (customTablesLoading) {
      return (
        <div className="CustomTables-loading-container">
          <div className="CustomTables-loading">Loading custom tables...</div>
        </div>
      );
    }
    return selectedTableData ? (
      <CustomTableView table={selectedTableData} onRowsSaved={handleRowsSaved} />
    ) : null;
  };

  return (
    <div>
      {renderBanner()}
      <div className="TaskTable-content">{renderContent()}</div>
    </div>
  );
};

export default IntegratedProjectTable;
